/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import allActions from "../../../Store/action";
import Message from "../../../components/forms/fields/Message";
import { useNavigate } from "react-router-dom";
import Ilustration from '../../../assets/img/onboarding-verification.svg'

const OnboardingVerification = ({
  user,
  setStep,
  isAppointmentBooked,
  isQuestionnaireCompleted,
  isVerify,
  license,
  taxpro_allow_appointments,
  isMessageSent,
  isPdfDownloaded
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [verificationMessage, setVerificationMessage] = useState({
    show: false,
    type: "",
    text: "",
  });

  useEffect(() => {
    if (verificationMessage.show) {
      setVerificationMessage((prev) => ({
        ...prev,
        type: "Success",
        text: `An email has been sent to ${user?.email} containing the verification link`,
      }));
    }
  }, [verificationMessage.show]);


  const handleNext = () => {
   if(taxpro_allow_appointments && !isAppointmentBooked) {
      navigate(
        `?lead=${user?.lead?.[0]?.uuid}&customer=${user?.uuid}&operator=${user?.lead[0]?.userpro?.uuid}`,
        { replace: true }
      );
      setStep((prev) => prev + 1);
      return;
    }
    if(!license){
      setStep((prev) => prev + 2);
      return;
    }
     if(!isQuestionnaireCompleted){
      setStep((prev) => prev + 3);
      return;
    }
     if(!isMessageSent){
      setStep((prev) => prev + 4);
      return;
    }
      if(!isPdfDownloaded){
        setStep((prev) => prev + 5);
       return
  }
    setStep((prev) => prev + 6)
    return;
  };
 

  return (
    <div className="d-flex justify-content-center align-items-center px-3">
      <div className="text-center w-100" >
        <h4 className="fw-bold text-primary fs-3">Account Verification</h4>
        <p className="text-black">Verify your account to continue</p>

        <img
          src={Ilustration}
          alt="Verification Email"
          className="img-fluid mt-2 my-4"
        />

        <p className="fw-semibold m-0 fs-6">
          Click on the verification link sent to your email
        </p>
        <p className="text-muted m-0">
          If it’s not in your inbox, check your <strong>Spam</strong> or <strong>Junk</strong> folder
        </p>

        <p>
          <button
            className="btn btn-link text-primary text-decoration-underline p-0 fw-bold mt-2"
            onClick={() =>
              dispatch(
                allActions.user.ResendLink(
                  {
                    email: user?.email,
                    leadconnectorWebhook: false,
                    role_id: user?.roles[0]?.id,
                  },
                  setVerificationMessage
                )
              )
            }
          >
            {verificationMessage?.type === "Sending" ? "Sending..." : "Resend Link"}
          </button>
        </p>

        {verificationMessage.show && (
          <Message message={verificationMessage} wrapperClass="container mt-2" />
        )}

        <div className="d-flex justify-content-between mt-2">
          <button
            className="btn btn-outline-primary px-4"
            onClick={() => setStep((prev) => prev - 1)}
          >
            ← Back
          </button>
          <button
            className="btn btn-primary px-4"
            onClick={handleNext}
          >
            Next Step →
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingVerification;
